"use strict";

var _defineProperty = require("/Users/patrickwitmer/Documents/web/millspublifyer/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/patrickwitmer/Documents/web/millspublifyer/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/patrickwitmer/Documents/web/millspublifyer/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/patrickwitmer/Documents/web/millspublifyer/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/patrickwitmer/Documents/web/millspublifyer/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/patrickwitmer/Documents/web/millspublifyer/node_modules/@babel/runtime/helpers/getPrototypeOf");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _requestanimationframeTimer = require("requestanimationframe-timer");

var _createTransitionContext = require("../context/createTransitionContext");

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/components/TransitionRenderer.js";

var TransitionRenderer = /*#__PURE__*/function (_react$Component) {
  _inherits(TransitionRenderer, _react$Component);

  var _super = _createSuper(TransitionRenderer);

  function TransitionRenderer() {
    var _this;

    _classCallCheck(this, TransitionRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      shouldBeVisible: !!!_this.props.appearAfter
    };

    _this.componentDidMount = function () {
      var delay = typeof _this.props.delay === 'number' ? _this.props.delay : 0;
      var appearafter = typeof _this.props.appearAfter === 'number' ? _this.props.appearAfter : 0;
      var timeout = delay + appearafter;
      _this.appearTimeout = (0, _requestanimationframeTimer.setTimeout)(function () {
        return _this.setState({
          shouldBeVisible: true
        });
      }, timeout);
    };

    _this.componentWillUnmount = function () {
      (0, _requestanimationframeTimer.clearTimeout)(_this.appearTimeout);
    };

    return _this;
  }

  _createClass(TransitionRenderer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      // only rerender if the transition status changes.
      return this.props.transitionStatus !== nextProps.transitionStatus || this.state.shouldBeVisible !== nextState.shouldBeVisible || this.props.children !== nextProps.children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mount = _this$props.mount,
          entryZindex = _this$props.entryZindex,
          exitZindex = _this$props.exitZindex,
          transitionStatus = _this$props.transitionStatus,
          transitionState = _this$props.transitionState,
          children = _this$props.children,
          injectPageProps = _this$props.injectPageProps;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-wrapper ".concat(mount ? 'tl-wrapper--mount' : 'tl-wrapper--unmount', " tl-wrapper-status--").concat(transitionStatus),
        style: {
          zIndex: mount ? entryZindex : exitZindex,
          opacity: this.state.shouldBeVisible ? 1 : 0
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 4
        }
      }, /*#__PURE__*/_react.default.createElement(_createTransitionContext.PublicProvider, {
        value: _objectSpread({}, transitionState),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 5
        }
      }, // injectPageProps is a plugin option
      injectPageProps ? /*#__PURE__*/(0, _react.cloneElement)(children, _objectSpread({}, transitionState)) : children));
    }
  }]);

  return TransitionRenderer;
}(_react.Component);

exports.default = TransitionRenderer;